import { NewFaxFormStyle } from './NewFaxForm.style'
import { NewFaxLoadingViewStyle } from './NewFaxLoadingView.style'

export const newFaxModalComponentStyles = {
  components: {
    NewFaxFormStyle,
    NewFaxLoadingViewStyle,
  },
}
